import { forwardRef } from 'react';
import Confetti from 'react-dom-confetti';

const AttendanceActions = forwardRef(function AttendanceActions({ submitAttendance, showConfetti }, confettiRef) {
  return (
    <div className="flex justify-end items-center mt-2 w-full">
      <div className="relative">
        <button
          ref={confettiRef}
          className="bg-green-600 text-white px-6 py-2 rounded-lg font-semibold shadow hover:bg-green-700 transition"
          onClick={submitAttendance}
        >
          Submit Attendance
        </button>
        {/* Confetti burst over button (clipped to hide scrollbar) */}
        <div className="absolute inset-0 pointer-events-none" style={{ zIndex: 10 }}>
          <div className="flex items-center justify-center">
            <Confetti active={showConfetti} />
          </div>
        </div>
      </div>
    </div>
  );
});

export default AttendanceActions; 
